import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import { useLazyGetOutlookMessageAttachmentContentQuery } from "../../redux/slices/graphApiSlice";
import PDFViewer from "./PDFViewer";
import { IOutlookMessageAttachment } from "../../types/outlookattachment";

interface IDriveItemViewerProps {
  outlookAttachment: IOutlookMessageAttachment;
  onSuccess?: () => void;
}
function OutlookAttachmentViewer({ ...props }: IDriveItemViewerProps) {
  const { outlookAttachment, onSuccess } = props;

  const { t } = useTranslation();
  const theme = useTheme();
  const isDownLg = useMediaQuery(theme.breakpoints.down("lg"));
  const [documentContent, setDocumentContent] = useState<any>();
  const [selectedVersion, setSelectedVersion] = useState<any>(null);

  const [
    getOutlookAttachmentContent,
    {
      data: outlookAttachmentContent,
      isLoading: gettingOutlookAttachmentContent,
    },
  ] = useLazyGetOutlookMessageAttachmentContentQuery({});

  useEffect(() => {
    if (outlookAttachment) {
      getOutlookAttachmentContent(outlookAttachment);
    }
  }, [outlookAttachment]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isDownLg ? "column-reverse" : "row",
      }}
    >
      <Box mr={8}>
        {gettingOutlookAttachmentContent ? (
          <Box textAlign="center">
            <CircularProgress />
          </Box>
        ) : (
          <PDFViewer
            {...props}
            arrayBuffer={outlookAttachmentContent}
            //arrayBuffer={documentContent}
            // base64string={outlookAttachment?.attachment?.contentBytes}
          />
        )}
      </Box>
    </Box>
  );
}

export default OutlookAttachmentViewer;
